export default __webpack_public_path__ + "static/media/Guru-Parampara-18.ba112cef.png";